export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/santacatarina.jpg',
	   "funcion": 'En el bulevar Santa Catarina, la Contraloría verificó la calidad de los materiales y el cumplimiento de lo establecido en el proyecto. #PrimeroElPueblo #ObrasQueTransforman',
		"url" : 'https://www.facebook.com/share/v/1DBmhKsFfk',
	},
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/contraloriaccion.jpg',
	    "funcion": 'Nuevo episodio de Contraloría en Acción Súper Honesta y Súper Responsable nos cuentan todo sobre el XXI Concurso Nacional Transparencia en Corto 2026 y las bases para participar. ',
		"url" : 'https://www.facebook.com/share/v/1D9S1Bi6EF',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/engaño.jpg',
	    "funcion": 'Quién engañó a Rod Castle? fue uno de los cortometrajes ganadores de la edición 2025 del Concurso Nacional de Transparencia en Corto.Este es un ejemplo de lo que puedes lograr con una buena historia, creatividad y muchas ganas de participar. ',
		"url" : 'https://www.facebook.com/share/v/1KFiM5CqiY',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]